// Shared month calendar panel shown on the board for everyone.
// KEEP IN SYNC with the dashboard original.

const WEEKDAYS = ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];

const CalendarOverlay = ({ calendar, isTeacher, onPage, onClose }) => {
    if (!calendar) return null;

    const { year, month } = calendar; // month: 1-12
    const first = new Date(year, month - 1, 1);
    const daysInMonth = new Date(year, month, 0).getDate();
    const startOffset = first.getDay(); // 0 = Sunday
    const today = new Date();
    const isThisMonth = today.getFullYear() === year && today.getMonth() === month - 1;
    const monthName = new Intl.DateTimeFormat("ar", { month: "long" }).format(first);

    const cells = [];
    for (let i = 0; i < startOffset; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);

    return (
        <div
            dir="rtl"
            style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 7,
                background: "#ffffff",
                color: "#1b2430",
                borderRadius: 16,
                boxShadow: "0 8px 40px rgba(0,0,0,0.3)",
                padding: "16px 20px",
                width: "min(420px, 92%)",
                fontFamily: "inherit",
            }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                {isTeacher && (
                    <button type="button" style={navBtn} onClick={() => onPage(-1)}>‹</button>
                )}
                <strong style={{ flex: 1, textAlign: "center", fontSize: "1.15rem" }}>
                    {monthName} {year}
                </strong>
                {isTeacher && (
                    <button type="button" style={navBtn} onClick={() => onPage(1)}>›</button>
                )}
                {isTeacher && (
                    <button type="button" style={{ ...navBtn, background: "#fbe5e5", color: "#a83a3a" }} onClick={onClose}>✕</button>
                )}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, textAlign: "center" }}>
                {WEEKDAYS.map((day) => (
                    <div key={day} style={{ fontSize: "0.72rem", fontWeight: 700, color: "#5b6b7a", padding: "4px 0" }}>
                        {day}
                    </div>
                ))}
                {cells.map((day, index) => (
                    <div
                        key={index}
                        style={{
                            padding: "7px 0",
                            borderRadius: 8,
                            fontVariantNumeric: "tabular-nums",
                            fontWeight: day && isThisMonth && day === today.getDate() ? 800 : 500,
                            background: day && isThisMonth && day === today.getDate() ? "#0080dc" : "transparent",
                            color: day && isThisMonth && day === today.getDate() ? "#fff" : undefined,
                        }}
                    >
                        {day || ""}
                    </div>
                ))}
            </div>
        </div>
    );
};

const navBtn = {
    border: "none",
    background: "#eef2f7",
    color: "#1b2430",
    borderRadius: 8,
    width: 32,
    height: 32,
    cursor: "pointer",
    fontSize: "1.1rem",
    lineHeight: 1,
};

export default CalendarOverlay;
